import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import BottomDrawer from '../Drawer/Drawer';
import { selectIsLoadingByActionTypes } from '../../store/selectors/loadingSelectors';
import {
  ACCOUNT_SETTINGS_LOADING,
  FETCH_ACCOUNT_ADDRESSES_LOADING,
} from '../../store/actions/account/accountActionConstants';
import DeliveryAddress from './DeliveryAddress';
import { pxToRem } from '../../assets/styles/helper';
import { variables } from '../../assets/styles/variables';
import themeColors from '../../assets/styles/themeColors';
import SectionLoader from '../Loader/SectionLoader';
import { selectIsAddAddressesEnabled } from '../../store/selectors/settingsSelectors';
import { useBrokerCode } from '../../util/hooks/useBrokerCode';
import NoAddress from './noAddress';

export const DeliveryAddressWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${pxToRem(12)};
`;

const AddNewAddressButton = styled.button`
  width: 100%;
  border-radius: ${variables.borderRadius.borderRadius};
  border: 1px dashed ${themeColors.colorGrey3};
  font-size: ${pxToRem(14)};
  line-height: 1.4;
  font-weight: 500;
  color: ${themeColors.colorTextPrimary};
  background-color: transparent;
  padding: ${pxToRem(10)};
  cursor: pointer;
`;

const NoAddressesLink = styled.p`
  color: ${themeColors.colorTextPrimary};
  text-decoration: underline;
  cursor: pointer;
  font-size: 12px;
  display: flex;
  align-self: flex-end;
`;

const SelectAddress = ({
  open,
  setOpen,
  setIsAddAddressOpen,
  addresses,
  // isDeliveryAddressSelected,
  setSelectedAddress,
  selectedAddress,
  countries,
  openSupport,
  isSupportOpen,
  setWizardData,
  wizardData,
}) => {
  const { t } = useTranslation();
  const isAddAddressesEnabled = useSelector(selectIsAddAddressesEnabled);
  const brokerCode = useBrokerCode();

  const [tempSelectedAddress, setTempSelectedAddress] = useState(
    selectedAddress || {},
  );

  const [isNoAddressOpen, setIsNoAddressOpen] = useState(false);

  const isLoading = useSelector(
    selectIsLoadingByActionTypes([
      FETCH_ACCOUNT_ADDRESSES_LOADING,
      ACCOUNT_SETTINGS_LOADING,
    ]),
  );

  useEffect(() => {
    if (open) {
      setTempSelectedAddress(selectedAddress);
    }
  }, [open, selectedAddress]);

  const handleClose = () => {
    if (tempSelectedAddress?.AddressUid) {
      setSelectedAddress(tempSelectedAddress);
    }
    setWizardData({
      ...wizardData,
      selectedAddress: tempSelectedAddress,
    });
    setOpen(false);
  };

  if (isNoAddressOpen) {
    return (
      <NoAddress
        open={isNoAddressOpen}
        setOpen={setIsNoAddressOpen}
        openSupport={openSupport}
        isSupportOpen={isSupportOpen}
        onBack={() => setIsNoAddressOpen(false)}
      />
    );
  }

  return (
    <BottomDrawer
      isOpen={open}
      onClose={handleClose}
      title={t('buyWizard.selectDeliveryAddress')}
    >
      <SectionLoader isLoading={isLoading}>
        <DeliveryAddressWrapper>
          {isAddAddressesEnabled && brokerCode !== 'HAA' && (
            <AddNewAddressButton onClick={() => setIsAddAddressOpen(true)}>
              {t('buyWizard.addNewAddress')}
            </AddNewAddressButton>
          )}
          {(brokerCode === 'HAA'
            ? addresses.filter((el) => el.IsVerified)
            : addresses
          ).map((address) => (
            <DeliveryAddress
              key={address.AddressUid}
              address={address}
              // isSelected={isDeliveryAddressSelected(address)}
              // onClick={setSelectedAddress}
              // isSelected={tempSelectedAddress.AddressUid === address.AddressUid}
              // isSelected={selectedAddress?.AddressUid === address.AddressUid}
              // onClick={() => {
              //   setTempSelectedAddress(address);
              //   setSelectedAddress(address);
              // }}
              // isCurrent={selectedAddress?.AddressUid === address.AddressUid}
              // onClick={() => setSelectedAddress(address)}
              isSelected={
                tempSelectedAddress?.AddressUid === address.AddressUid
              }
              // isCurrent={tempSelectedAddress?.AddressUid === address.AddressUid}
              onClick={() => setTempSelectedAddress(address)}
              countries={countries}
            />
          ))}
          <NoAddressesLink onClick={() => setIsNoAddressOpen(true)}>
            {t('buyWizard.noAddressesLink')}
          </NoAddressesLink>
        </DeliveryAddressWrapper>
      </SectionLoader>
    </BottomDrawer>
  );
};

SelectAddress.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  wizardData: PropTypes.shape({
    selectedVault: PropTypes.shape({
      LocationType: PropTypes.number,
    }),
  }),
  setWizardData: PropTypes.func,
  setIsAddAddressOpen: PropTypes.func,
  addresses: PropTypes.arrayOf(PropTypes.shape({})),
  // isDeliveryAddressSelected: PropTypes.bool,
  setSelectedAddress: PropTypes.func,
  selectedAddress: PropTypes.shape({}),
  countries: PropTypes.arrayOf(PropTypes.shape({})),
  openSupport: PropTypes.func,
  isSupportOpen: PropTypes.bool,
};

export default SelectAddress;
